export function toEnglishNumber(str){
    const persianNumbers = ["۰","۱","۲","۳","۴","۵","۶","۷","۸","۹"];
    let result = str;
    for(let i in persianNumbers){
        result = result.replaceAll(persianNumbers[i],i)
    }
    return result;
}